var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.430992 5.24004L5.17725 7.46913L5.44383 3.45326L0.430992 5.24004Z",
    fill: "#DC4649",
    stroke: "#DC4649",
    strokeWidth: 0.861887,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.448 5.84955L5.43108 7.37485L5.74325 3.36226L10.448 5.84955Z",
    fill: "#DC4649",
    stroke: "#DC4649",
    strokeWidth: 0.861887,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.18989 10.1088L4.58017 7.60952L7.65534 5.01305L9.18989 10.1088Z",
    fill: "#DC4649",
    stroke: "#DC4649",
    strokeWidth: 0.861887,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.26696 10.431L6.87668 7.93178L3.80151 5.33532L2.26696 10.431Z",
    fill: "#DC4649",
    stroke: "#DC4649",
    strokeWidth: 0.861887,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.95881 0.430868L7.4841 5.44777L3.47151 5.1356L5.95881 0.430868Z",
    fill: "#DC4649",
    stroke: "#DC4649",
    strokeWidth: 0.861887,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.64d136c40c0d11b859b394258a622bf7.svg";
export { ForwardRef as ReactComponent };